// extracted by mini-css-extract-plugin
module.exports = {"item":"Tweet_item__3zPQO","footer":"Tweet_footer__1dfYF"};